import { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import Box from '@/components/ui/Box/Box';
import Typography from '@/components/ui/Typography/Typography';
import animation from '@/assets/lottie-loading.json';
import type { LoadingProps } from './ILoading';
import { styles } from './styles';

const Loading = ({
    loading,
    fullScreen = true,
    width = 200,
    height = 200,
    timeout = 30_000,
    onTimeout,
    timeoutMessage = '',
}: LoadingProps) => {
    const [timedOut, setTimedOut] = useState(false);

    useEffect(() => {
        if (!loading) return;
        const timer = window.setTimeout(() => {
            setTimedOut(true);
            onTimeout?.();
        }, timeout);
        return () => window.clearTimeout(timer);
    }, [loading, timeout, onTimeout]);

    if (!loading) return null;

    if (!timedOut) {
        return (
            <Box sx={fullScreen ? styles.fullScreenContainer : styles.container}>
                <Lottie
                    animationData={animation}
                    loop
                    style={{ width, height }}
                />
            </Box>
        );
    }

    return (
        <Box sx={styles.container}>
            <Typography p={1} m={1} sx={styles.message}>
                {timeoutMessage}
            </Typography>
        </Box>
    );
};

export default Loading;
